import { FacilityOptionMaintenanceSaveRequest } from './../pages/facility-option-maintenance/interfaces/facility-option-maintenance-save-request';
import { FacilityOptionMaintenanceGetResponse } from './../pages/facility-option-maintenance/interfaces/facility-option-maintenance-get-response';
import { FacilityOptionMaintenanceGetRequest } from './../pages/facility-option-maintenance/interfaces/facility-option-maintenance-get-request';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FacilityOptionMaintenanceService {

  private baseUrl: string = `${environment.logisticsApiUrl}/facilityOptions/maintenance`
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }
  constructor(
    private http: HttpClient
  ) { }

  getFacilityOptions(request: FacilityOptionMaintenanceGetRequest): Observable<FacilityOptionMaintenanceGetResponse> {
    return this.http.post<FacilityOptionMaintenanceGetResponse>(this.baseUrl, request, this.httpOptions);
  }

  saveFacilityOptionChanges(request: FacilityOptionMaintenanceSaveRequest): Observable<void> {
    return this.http.put<void>(this.baseUrl, request, this.httpOptions);
  }
}
